
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceDirectionTrue as ObiForceDirectionTrueElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-direction-true.js';
 
 
 

 
 export const ObiForceDirectionTrue = createComponent({
   react: React,
   tagName: 'obi-force-direction-true',
   elementClass: ObiForceDirectionTrueElement,
   events: {
     
   }
  });
 
 